var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2103 150.2C116.687 150.2 150.31 116.577 150.31 75.1C150.31 33.6234 116.687 0 75.2103 0C33.7338 0 0.110352 33.6234 0.110352 75.1C0.110352 116.577 33.7338 150.2 75.2103 150.2Z",
    fill: "url(#paint0_linear_339_497)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2101 133.23C107.314 133.23 133.34 107.204 133.34 75.1C133.34 42.9957 107.314 16.97 75.2101 16.97C43.1058 16.97 17.0801 42.9957 17.0801 75.1C17.0801 107.204 43.1058 133.23 75.2101 133.23Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.25 79.89V69.66C105.19 68.69 108.12 65.13 108.12 60.9C108.12 55.93 104.07 51.88 99.1 51.88C96.55 51.88 94.24 52.95 92.6 54.66L83.73 49.54C83.96 48.74 84.09 47.9 84.09 47.03C84.09 42.06 80.04 38.01 75.07 38.01C70.1 38.01 66.05 42.06 66.05 47.03C66.05 47.9 66.18 48.74 66.41 49.54L57.54 54.66C55.9 52.95 53.59 51.88 51.04 51.88C46.05 51.88 42 55.92 42 60.9C42 65.13 44.93 68.69 48.87 69.66V79.82C44.93 80.79 42 84.35 42 88.58C42 93.55 46.05 97.6 51.02 97.6C53.55 97.6 55.84 96.55 57.48 94.87L66.4 100.02C66.17 100.82 66.04 101.66 66.04 102.53C66.04 107.5 70.09 111.55 75.06 111.55C80.03 111.55 84.08 107.5 84.08 102.53C84.08 101.66 83.95 100.82 83.72 100.02L92.59 94.9C94.23 96.61 96.54 97.68 99.09 97.68C104.06 97.68 108.11 93.63 108.11 88.66C108.11 84.43 105.18 80.87 101.24 79.9L101.25 79.89ZM81.56 96.29C79.92 94.58 77.61 93.51 75.05 93.51C72.49 93.51 70.19 94.58 68.54 96.29L59.65 91.16C59.89 90.34 60.03 89.48 60.03 88.58C60.03 84.35 57.1 80.79 53.16 79.82V69.66C57.1 68.69 60.03 65.13 60.03 60.9C60.03 60.03 59.9 59.18 59.67 58.39L68.54 53.27C70.18 54.98 72.49 56.05 75.05 56.05C77.61 56.05 79.91 54.98 81.56 53.27L90.43 58.39C90.2 59.19 90.07 60.03 90.07 60.9C90.07 65.13 93 68.69 96.94 69.66V79.89C93 80.86 90.07 84.42 90.07 88.65C90.07 89.52 90.2 90.37 90.43 91.16L81.56 96.28V96.29Z",
    fill: "#7AAE01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_497",
    x1: 18.6704,
    y1: 124.52,
    x2: 130.84,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AAE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87B90F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9BC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A7D231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABD636"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.12,
    height: 73.55,
    fill: "white",
    transform: "translate(42 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission04);
export default __webpack_public_path__ + "static/media/Mission-04.13747ca8013207385801e848de9d661f.svg";
export { ForwardRef as ReactComponent };